"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = exports.SocialCards = exports.SocialCard = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pixelated = require("../utilities/pixelated.functions");
require("./pixelated.socialcard.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ==========
NOTE - FourSquare RSS stopped working March 2019
========== */

/* ========== SOCIALCARDS ========== */
class SocialCards extends _react.Component {
  constructor(props) {
    super(props);
    this.debug = false;
    this.state = {
      loading: true,
      targetID: '#social',
      myPromises: [],
      promiseReady: false,
      cardCount: 0,
      myCardData: [],
      mySocialCards: [],
      rss2json: {
        apiURL: 'https://api.rss2json.com/v1/api.json',
        apiKey: 'c3wsmqh4h1iydxxip3sgkr1jtk3brllbp61jc6yd'
      },
      sources: {
        blank: {
          url: '',
          entryCount: 5,
          iconSrc: '',
          iconSrcAlt: ''
        },
        SOOpx: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/500px-logo.png',
          iconSrcAlt: '500px Post'
        },
        blog: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/blog-logo.png',
          iconSrcAlt: 'Blog Post'
        },
        etsy: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/etsy-logo.png',
          iconSrcAlt: 'Etsy Favorite'
        },
        /* facebook: {
              iconSrc: 'images/logos/facebook-logo.png',
              iconSrcAlt: 'Facebook Wall Post'
            }, */
        flickr: {
          userID: '',
          apiKey: '',
          tags: '',
          entryCount: 5,
          iconSrc: 'images/logos/flickr-logo.png',
          iconSrcAlt: 'Flickr Photo'
        },
        /* foursquare: {
        	url: '',
        	entryCount: 5,
        	iconSrc: 'images/logos/foursquare-logo.png',
        	iconSrcAlt: 'FourSquare Checkin'
        	}, */
        goodreads: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/goodreads-logo.png',
          iconSrcAlt: 'GoodReads Currently Reading'
        },
        instagram: {
          userID: '',
          entryCount: 5,
          iconSrc: 'images/logos/instagram-logo.jpg',
          iconSrcAlt: 'Instagram Photo'
        },
        pinterest: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/pinterest-logo.png',
          iconSrcAlt: 'Pinterest Pin'
        },
        shutterfly: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/shutterfly-logo.jpg',
          iconSrcAlt: 'Shutterfly Items'
        },
        tumblr: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/tumblr-logo.png',
          iconSrcAlt: 'Tumblr Post'
        },
        twitter: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/twitter-logo.png',
          iconSrcAlt: 'Twitter Tweet'
        },
        youtube: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/youtube-logo.png',
          iconSrcAlt: 'Youtube Favorite Video'
        },
        other: {
          url: '',
          entryCount: 5,
          iconSrc: 'images/logos/blog-logo.png',
          iconSrcAlt: 'Post'
        }
      }
    };
    this.state.sources = (0, _pixelated.mergeDeep)(this.state.sources, props.sources);
  }
  gatherData() {
    if (this.debug) {
      console.log('Gathering Data...');
    }
    for (const prop in this.state.sources) {
      const source = this.state.sources[prop];
      if (Object.prototype.hasOwnProperty.call(source, 'url') && source.url) {
        this.getFeedEntries(source.url, source.entryCount);
      }
    }
    /* if(this.state.flickr.userID){ this.getFlickrEntries(this.state.flickr.userID, this.state.flickr.apiKey, this.state.flickr.tags, this.state.flickr.entryCount); } */
    /* if(this.state.goodreads.url){ this.getGoodreadsEntries(this.state.goodreads.url, this.state.goodreads.entryCount); } */
    /* if(this.state.instagram.userID){ this.getInstagramEntries(this.state.instagram.userID, this.state.instagram.entryCount); } */
  }

  getFeedEntries(myURL, entryCount) {
    if (this.debug) {
      console.log('Getting Feed Entries...');
    }
    const apiKey = this.state.rss2json.apiKey;
    const result = fetch(this.state.rss2json.apiURL + '?rss_url=' + encodeURIComponent(myURL) + '&api_key=' + apiKey + '&count=' + entryCount, {
      method: 'GET',
      credentials: 'same-origin'
    }).then(res => res.json()).then(result => {
      let i = 0;
      for (const prop in result.items) {
        let myNewCard = [];
        const item = result.items[prop];
        myNewCard = item;

        /* ===== FIX FOR DESCRIPTION ===== */
        if (item.content) {
          if (item.content.length > 500) {
            const doc = (0, _pixelated.html2dom)(item.content);
            const itemContent = doc.innerHTML;
            myNewCard.content = itemContent;
          }
        } else {
          const myImgBase = item.thumbnail;
          const myImgTag = '<img src="' + myImgBase + '" alt="' + item.title + '" title="' + item.title + '">';
          myNewCard.content = '<p>' + myImgTag + item.title + '</p>';
          /* myNewCard.description = myNewCard.content; */
        }
        /* ===== UPDATE STATE ===== */
        const myCardDataFromState = this.state.myCardData;
        myCardDataFromState.push(myNewCard);
        myCardDataFromState.sort(this.sortCardsByPubDate);
        this.setState({
          myCardData: myCardDataFromState
        });
        if (i >= entryCount) {
          return false;
        }
        i++;
      }
    },
    // Note: it's important to handle errors here
    // instead of a catch() block so that we don't swallow
    // exceptions from actual bugs in components.
    error => {
      console.log(error + ' \n RSS2JSON API Call failed.');
    });
    /* ===== UPDATE STATE ===== */
    (0, _pixelated.pushNewValueToStateArray)(this, 'myPromises', result);
  }
  sortCardsByPubDate(a, b) {
    const property = 'pubDate';
    const dateA = new Date(a[property]);
    const dateB = new Date(b[property]);
    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    } else {
      return 0;
    }
  }
  componentDidMount() {
    let myOptions = [];
    this.gatherData();
    /* Promise.all(this.state.myPromises).then( result => { */
    // Promise.all(this.state.myPromises).then(function(){
    Promise.all(this.state.myPromises).then(() => {
      for (const prop in this.state.myCardData) {
        const card = this.state.myCardData[prop];
        switch (true) {
          case card.link.indexOf('500px.com') > -1:
            myOptions = this.state.sources.SOOpx;
            break;
          case card.link.indexOf('blog') > -1:
            myOptions = this.state.sources.blog;
            break;
          case card.link.indexOf('etsy.com') > -1:
            myOptions = this.state.sources.etsy;
            break;
          case card.link.indexOf('foursquare.com') > -1:
            myOptions = this.state.sources.foursquare;
            break;
          case card.link.indexOf('flickr.com') > -1:
            myOptions = this.state.sources.flickr;
            break;
          case card.link.indexOf('goodreads.com') > -1:
            myOptions = this.state.sources.goodreads;
            break;
          case card.link.indexOf('instagram') > -1:
            myOptions = this.state.sources.instagram;
            break;
          case card.link.indexOf('pinterest.com') > -1:
            myOptions = this.state.sources.pinterest;
            break;
          case card.link.indexOf('shutterfly.com') > -1:
            myOptions = this.state.sources.shutterfly;
            break;
          case card.link.indexOf('tumblr.com') > -1:
            myOptions = this.state.sources.tumblr;
            break;
          case card.link.indexOf('twitter') > -1:
            myOptions = this.state.sources.twitter;
            break;
          case card.link.indexOf('youtube') > -1:
            myOptions = this.state.sources.youtube;
            break;
          case card.link.indexOf('other') > -1:
            myOptions = this.state.sources.other;
            break;
          default:
            myOptions = this.state.sources.blank;
            break;
        }
        /* ===== UPDATE STATE ===== */
        const newSocialCard = /*#__PURE__*/_react.default.createElement(SocialCard, {
          key: prop + '' + card.guid,
          iconSrc: myOptions.iconSrc,
          iconSrcAlt: myOptions.iconSrcAlt,
          card: card
        });
        (0, _pixelated.pushNewValueToStateArray)(this, 'mySocialCards', newSocialCard);
        this.setState({
          cardCount: prop
        });
      }
      this.setState({
        loading: false,
        promiseReady: true
      });
    });
  }
  render() {
    if (this.state.loading) {
      return /*#__PURE__*/_react.default.createElement(Spinner, null);
    } else {
      return this.state.mySocialCards;
    }
  }
}

/* ========== SOCIALCARD ========== */
exports.SocialCards = SocialCards;
_defineProperty(SocialCards, "propTypes", {
  sources: _propTypes.default.object.isRequired
});
class SocialCard extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "masonry-item",
      key: this.props.card.guid
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "cardTitle"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.card.link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "cardIcon",
      src: this.props.iconSrc,
      alt: this.props.iconSrcAlt
    }), this.props.card.title)), /*#__PURE__*/_react.default.createElement("div", {
      className: "cardBody",
      dangerouslySetInnerHTML: {
        __html: this.props.card.content
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "cardDate"
    }, this.props.card.pubDate)));
  }
}

/* ========== SPINNER ========== */
exports.SocialCard = SocialCard;
_defineProperty(SocialCard, "propTypes", {
  iconSrc: _propTypes.default.string.isRequired,
  iconSrcAlt: _propTypes.default.string.isRequired,
  card: _propTypes.default.object.isRequired
});
class Spinner extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "spinner"
    }, /*#__PURE__*/_react.default.createElement("div", null, "Loading..."));
  }
}
exports.Spinner = Spinner;